import { useIsAuthenticated } from '@azure/msal-react';
import { ReactNode, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import useAuthUserInfo from '../hooks/useAuthUserInfo';
import { Role } from '../types/user';

interface ProtectedRouteProps {
  children?: ReactNode;
  requiredRoles?: Role[];
}

const ProtectedRoute = ({
  children,
  requiredRoles = [],
}: ProtectedRouteProps) => {
  const isAuthenticated = useIsAuthenticated();
  const { hasRole, userRole } = useAuthUserInfo();
  const navigate = useNavigate();

  const isAuthorized =
    isAuthenticated &&
    Boolean(userRole) &&
    (requiredRoles.length === 0 || hasRole(...requiredRoles));

  useEffect(() => {
    if (isAuthenticated && !isAuthorized) {
      void navigate('/unauthorized', { replace: true });
    }
  }, [isAuthenticated, isAuthorized, navigate]);

  if (!isAuthorized) {
    return null;
  }

  return children ?? <Outlet />;
};

export default ProtectedRoute;
